module.exports = __webpack_public_path__ + "static/img/12-1.77debb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/12-1.jpg
// module id = wMfg
// module chunks = 0